import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import {Component, EventEmitter, Inject, OnDestroy, OnInit} from '@angular/core';
import { takeUntil } from 'rxjs/operators';
import { AnessaTranslationService } from '../../../helper/translation/anessa-translation.service';
import { UserpilotReloader } from '../../../helper/userpilot-reloader.component';

@Component({
  selector: 'topbar-profile-dialog',
  templateUrl: './topbar-profile-dialog.component.html',
  styleUrls: [
    './topbar-profile-dialog.component.scss'
  ]
})
export class TopbarProfileDialogComponent extends UserpilotReloader implements OnInit, OnDestroy {
  onDestroyNotifier = new EventEmitter();
  /** trigger for translation pipe */
  trigger?: string;

  constructor(public dialogRef: MatDialogRef<TopbarProfileDialogComponent>,
              public translationService: AnessaTranslationService,
              @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    super();
  }

  onCancel() {
    this.dialogRef.close();
  }

  ngOnInit() {
    this.translationService.languageChangeNotifier
      .pipe(takeUntil(this.onDestroyNotifier))
      .subscribe(() => {
        this.trigger = this.translationService.getCurrentLang();
      });
  }

  ngOnDestroy() {
    this.onDestroyNotifier.emit();
    this.onDestroyNotifier.unsubscribe();
  }
}
